const phoneFormat = (value: string) => {
	if (!value) return value;
	const str = `${value}`.replace('+55', '');
	const onlyNums = str.replace(/[^\d]/g, '');
	if (onlyNums.length <= 2) return onlyNums;
	if (onlyNums.length <= 7)
		return `(${onlyNums.slice(0, 2)}) ${onlyNums.slice(2, 7)}`;

	if (onlyNums.length <= 10)
		return `(${onlyNums.slice(0, 2)}) ${onlyNums.slice(2, 6)}-${onlyNums.slice(
			6,
			11,
		)}`;

	return `(${onlyNums.slice(0, 2)}) ${onlyNums.slice(2, 7)}-${onlyNums.slice(
		7,
		11,
	)}`;
};

export default phoneFormat;
